module.exports = __webpack_public_path__ + "russierenouvelables/img/github.b40aba57.webp";